/* istanbul ignore file */
import { createContext } from 'react';

import type { Store } from '@lumapps/redux/react';

import { RouterApi } from '../api';

export interface RouterFactoryOptions {
    store: Pick<Store, 'getState'>;
}

export interface RouterProps {
    currentView?: string;
    params?: any;
    isBackOffice?: boolean;
    getRedirect?: (options: RouterFactoryOptions) => RouterApi['redirect'];
    getUrl?: (options: RouterFactoryOptions) => RouterApi['getUrl'];
}

const Context = createContext<RouterProps>({
    currentView: '',
    params: {},
    isBackOffice: false,
});

export { Context };
